module.exports = "<span class=\"padding-10\">\r\n  <em class=\"badge padding-5 no-border-radius bg-color-blueLight pull-left margin-right-5\">\r\n    <i [ngClass]=\"setClasses()\"></i>\r\n  </em>\r\n  <span>{{item.message}}<br/>\r\n    <span class=\"pull-right font-xs text-muted\"><i>{{item.time}}</i></span>\r\n  </span>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/activities/activities-notification/activities-notification.component.html
// module id = ../../../../../src/app/shared/layout/header/activities/activities-notification/activities-notification.component.html
// module chunks = main